const labels = {
  basicinformation: [
    'All of Basic Information',
    'Title',
    'Authors',
    'Quest Manager',
    'Driving Question',
    'Quest Goal',
    'Description',
    'Intended Journey/Level',
    'Primary Subject',
    'Target Grade',
    'Group Quest',
    'Just for Mentors'
  ],
  topicsandstandards: ['Topics & Standards'],
  activities: [
    'All of Activity',
    'Title',
    'Activity Goals',
    'Description',
    'Artifact',
    'Resources',
    'Notes for Mentors',
    'Assessment Questions for Mentors',
    'File for Mentors'
  ],
  images: ['Quest Icon'],
  otherinformation: [
    'All of Other Information',
    'Unusual Materials',
    'Tags',
    'Inspiration'
  ],
  questreview: [
    'All of Quest Review',
    'Internal Review - Experience',
    'Internal Review - Subject',
    'Internal Review - Copy',
    'Publication Review - Standards',
    'Publication Review - Final'
  ],
  skills: ['Skills']
}

export default labels



// WEBPACK FOOTER //
// ./src/utils/commentlabels.js